const createMonitor = (properties = {}) => {
  const isValid = () => {
    const requiredProperties = ['isConfigured', 'setup', 'log', 'isActive'];
    requiredProperties.forEach(property => {
      if (!properties[property] && typeof properties[property] !== 'function') {
        throw new Error(`Monitor must have ${property} property`);
      }
    });
    return true;
  };

  return {
    ...properties,
    isValid
  };
};

module.exports = createMonitor;
